/* eslint-disable no-undef */
// import { mapGetters } from 'vuex'
var meta = {
  data () {
    return {
      // debug: false
    }
  },
  computed: {
  },
  methods: {
    meta_return_item (value) {
      if (!value) return []
      const buildItem = (item) => {
        if (!item) return null
        const newItem = {
          id: item.id || '',
          quantity: item.quantity || 1
        }
        return newItem
      }
      return Array.isArray(value)
        ? value.map(item => buildItem(item)).filter(Boolean)
        : [buildItem(value)]
    },

    meta_add_to_cart (item) {
      fbq('track', 'AddToCart')
    },

    meta_purchase_track (orderData, products) {
      fbq('track', 'Purchase',
        {
          value: Number(this.calcAmount),
          currency: 'TWD',
          contents: this.meta_return_item(products),
          content_type: 'product'
        }
      )
      if (window.gtag) {
        window.gtag('event', 'conversion', {
          send_to: 'AW-17743379847/aqWGCL667MIbEIf72YxC',
          value: Number(this.calcAmount),
          currency: 'TWD',
          transaction_id: orderData.order_id
        })
      }
    },
    gtagReportConversion () {
      if (!window.gtag) return

      window.gtag('event', 'conversion', {
        send_to: 'AW-17743379847/LTnVCLLW8cIbEIf72YxC'
      })
    }
  }
}

export default meta
